"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowRejectionReason = void 0;
var WorkflowRejectionReason;
(function (WorkflowRejectionReason) {
    WorkflowRejectionReason["CustomerAlreadyInformed"] = "CustomerAlreadyInformed";
    WorkflowRejectionReason["CustomerWillNotBeChargedFortoHandlingIssue"] = "CustomerWillNotBeCharged_FortoHandlingIssue";
    WorkflowRejectionReason["CustomerWillNotBeChargedPartnerHandlingIssue"] = "CustomerWillNotBeCharged_PartnerHandlingIssue";
    WorkflowRejectionReason["CustomerWillNotBeChargedOther"] = "CustomerWillNotBeCharged_Other";
    WorkflowRejectionReason["IncorrectDataRates"] = "IncorrectData_Rates";
    WorkflowRejectionReason["IncorrectDataTimestamps"] = "IncorrectData_Timestamps";
    WorkflowRejectionReason["CommercialDecision"] = "CommercialDecision";
    WorkflowRejectionReason["NonInspectionEvent"] = "NonInspectionEvent";
    WorkflowRejectionReason["IncorrectData"] = "IncorrectData";
    WorkflowRejectionReason["Other"] = "Other";
})(WorkflowRejectionReason || (exports.WorkflowRejectionReason = WorkflowRejectionReason = {}));
//# sourceMappingURL=workflowRejectionReason.enum.js.map